const CONFIG = {
  googlePlacesAPI: process.env.REACT_APP_GOOGLE_PLACES_API
};

export default CONFIG;
